import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "login-wrapper"
}
const _hoisted_3 = { class: "login-right" }
const _hoisted_4 = { class: "login-right-content" }
const _hoisted_5 = { class: "form-floating-custom" }
const _hoisted_6 = { class: "form-floating-custom" }
const _hoisted_7 = { class: "login-options" }
const _hoisted_8 = { class: "icheck-success" }
const _hoisted_9 = {
  key: 0,
  type: "submit",
  class: "btn-login-main"
}
const _hoisted_10 = {
  key: 1,
  class: "btn-login-main",
  type: "button",
  disabled: ""
}
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoaderComponent),
    (_ctx.isEntraLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.isEntraLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "login-left" }, [
            _createElementVNode("h1", { class: "main-title" }, [
              _createTextVNode("Welcome back to"),
              _createElementVNode("br"),
              _createTextVNode("Clementine Analytics")
            ]),
            _createElementVNode("p", { class: "main-subtitle" }, "Secure access to your enterprise data and analytics")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "login-header-text" }, [
                _createElementVNode("h2", null, "Sign In"),
                _createElementVNode("p", null, "Access your secure workspace")
              ], -1)),
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args))),
                class: "w-100"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-envelope input-icon" }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    name: "email",
                    id: "loginEmail",
                    placeholder: " ",
                    type: "email",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                    required: "",
                    autocomplete: "email"
                  }, null, 512), [
                    [_vModelText, _ctx.form.email]
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("label", { for: "loginEmail" }, "Email Address", -1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-lock input-icon" }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    name: "password",
                    id: "loginPassword",
                    placeholder: " ",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                    required: "",
                    autocomplete: "current-password"
                  }, null, 512), [
                    [_vModelText, _ctx.form.password]
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("label", { for: "loginPassword" }, "Password", -1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "rememberMe",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.rememberMe]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", { for: "rememberMe" }, "Remember Me", -1))
                  ]),
                  _createElementVNode("a", {
                    class: "forgot-password-link",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/forget-password')))
                  }, "Forgot password?")
                ]),
                (!_ctx.isLoginLoader)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_9, "Sign In"))
                  : (_openBlock(), _createElementBlock("button", _hoisted_10, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("span", {
                        class: "spinner-border spinner-border-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Signing in... ", -1)
                    ]))])),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "login-separator" }, [
                  _createElementVNode("span", null, "or sign in with")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-login-microsoft",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMicrosoftLogin && _ctx.onMicrosoftLogin(...args))),
                  disabled: _ctx.isLoginLoader
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("img", {
                    src: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
                    alt: "Microsoft",
                    style: {"height":"1.25em"}
                  }, null, -1),
                  _createElementVNode("span", null, "Sign in with Microsoft", -1)
                ]))], 8, _hoisted_11)
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}